import { SituacaoContribuinteEmpresaEnum } from '../../../enums/motor-fiscal/situacao-contribuinte-empresa.enum';
import { EmpresaInscricaoSubstitutoTributarioStruct } from '../../structs/usuario/empresa-inscricao-substituto-tributario.struct';

/**
 * Payload do PUT Empresa/dadosFiscais/idEmpresa/{idEmpresa}.
 *
 * Só os campos editáveis da tela. Nome Empresa, CNPJ, Fuso e Endereço deliberadamente não
 * trafegam aqui — o backend também não os aceita.
 */
export class EmpresaDadosFiscaisRequest {
  nomeFantasia: string | null;
  /**
   * Data no formato `yyyy-MM-dd`, sem hora. A coluna é `date`; enviar como string evita o
   * deslocamento de fuso que um ISO com horário causaria (dia anterior em UTC-03).
   */
  dataFundacao: string | null;
  /** Subclasse canônica (7 dígitos, `6201501`) ou o valor aberto como digitado. */
  cnaePrincipal: string | null;
  idRegimeTributario: number | null;
  /**
   * Só acompanha o Regime Normal; nos demais vai null. Quem zera é a tela: a API Usuário não
   * alcança o db_motor_fiscal para saber qual id é o Regime Normal.
   */
  idRegimeApuracaoIrpj: number | null;
  /** Só aceita valor com a empresa contribuinte de ICMS; nos demais enquadramentos vai null. */
  inscricaoEstadual: string | null;
  /** Situação perante o ICMS (SituacaoContribuinteEmpresaEnum). */
  idSituacaoContribuinteEmpresa: SituacaoContribuinteEmpresaEnum;
  inscricaoMunicipal: string | null;
  inscricaoSuframa: string | null;
  /** Lista completa — o backend reconcilia contra o que está gravado. */
  listaInscricaoSubstitutoTributario: EmpresaInscricaoSubstitutoTributarioStruct[];
}
